import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608ec28a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reg_modal" }
const _hoisted_2 = { class: "card card body border-0 d_container pb-0 pt-3" }
const _hoisted_3 = { class: "sub_container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Register as an", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Innovator", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Register as an", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Partner", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: _ctx.registerModal,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: "",
      class: "hide_close",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/innovator/innovator-registration",
              class: "section_1"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/partner/partner-registration",
              class: "section_1"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_router_link, {
            to: "/priority-needs/submit",
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Or submit an identified health need")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}